import React from 'react';
import { browserHistory } from 'react-router';
import * as actions from '../../redux/actions';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import $ from 'jquery';
import { DEFAULT_PATH } from '../../Util';
import ReactSpinner from 'react-spinjs';

class LoginPage extends React.Component {
  state = {
    loginError: '',
    loggingIn: false,
  };

  componentWillUnmount() {
    this.unmounted = true;
  }

  componentDidMount() {
    reloadPageWhenVersionChanged();
  }

  handleLogin(values) {
    let { dispatch, location } = this.props;
    let { email, password } = values;

    this.setState({ loggingIn: true });

    let promise = dispatch(actions.loginUserWithPassword(email, password));
    promise.then((user) => {
      let next = location.query.next || DEFAULT_PATH;
      // migrate to old '/kiosk/prod' to new '/kiosk/adm'
      if (next === '/kiosk/prod') {
        next = DEFAULT_PATH;
      }
      if (user.isCommissionRole()) {
        next = '/commission';
      }
      if (next.startsWith('/id/') || next.startsWith('/user/')) {
        // push two paths so that when back button is click on host detail page, it will go back to host list page
        browserHistory.push(DEFAULT_PATH);
      }
      if (!this.unmounted) this.setState({ loggingIn: false });
      browserHistory.push(next);
    });
    promise.catch((e) => {
      this.setState({ loginError: e.message, loggingIn: false }, () => {
        let $loginError = $(this.refs.loginError);
        $loginError.removeClass('animated fadeIn');
        setTimeout(() => $loginError.addClass('animated fadeIn'), 200);
      });
    });
  }

  render() {
    let { loginError, loggingIn } = this.state;
    return (
      <div className='login-container'>
        <LoginForm onSubmit={this.handleLogin.bind(this)} loggingIn={loggingIn} />
        {loginError && (
          <span className='login-error' ref='loginError'>
            {loginError}
          </span>
        )}
        <div style={{ color: 'white', position: 'absolute', bottom: 20, right: 20 }}>
          {window.DASHWEB_VER}
        </div>
        {loggingIn && <ReactSpinner />}
      </div>
    );
  }
}

const LoginForm = reduxForm({ form: 'loginForm' })((props) => {
  const { handleSubmit, submitting, loggingIn } = props;
  return (
    <form className='login-content' action='/login' onSubmit={handleSubmit}>
      <div className='login-title'>
        <img src='../img/dash-logo.png' style={{ height: 20 }} />
      </div>
      <Field
        className='login-input'
        name='email'
        component='input'
        type='text'
        placeholder='Email'
        autoFocus={true}
      />
      <Field
        className='login-input'
        name='password'
        component='input'
        type='password'
        placeholder='Password'
      />
      <button
        className='login-submit-button pure-button button-primary'
        name='loginbutton'
        type='submit'
        disabled={submitting || loggingIn}
        style={{ opacity: loggingIn ? 0.3 : 1 }}
      >
        Login
      </button>
    </form>
  );
});

function reloadPageWhenVersionChanged() {
  let curVer = window.DASHWEB_VER;
  let prevVer = localStorage.getItem('dashweb.version');
  localStorage.setItem('dashweb.version', curVer);
  if (curVer !== prevVer) {
    //alert('reloading...');
    // to force to clear browser cache of style.css and main.js when version changed
    window.location.reload(true);
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/components/pages/LoginPage.js